"use strict";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "picturefill";
import "./framework/base.js";
import "./components/uif_form";

import LanguageSelection from "./components/c09.01_language-selection.js";
import LanguageFooter from "./components/c09.02_language-footer.js";
import HeaderNav from "./components/c01.02_header-navigation.js";
import SocialFeed from "./components/c03.02_social-feed.js";
import Feedback from "./components/c05.01_feedback.js";
import LocationSearch from "./components/c06.06_location-search.js";
import wffm from "./components/c05.03_wffm-form.js";
import EventTicketList from "./components/c05.04_event-ticket-form.js";
import ShopMap from "./components/c06.01_shop-map.js";
import ShopDetails from "./components/c06.09_shop-details.js";
import ServicesList from "./components/c06.14_services-list.js";
import CookieBanner from "./components/c07.03_cookie-banner.js";
import PostcodeLookup from "./components/uif_postcode-lookup.js";
import ToolkitNavigation from "./components/toolkit-navigation.js";
import Lightbox from "./components/c08.03_lightbox.js";
import BookWheelchairValidation from "./components/c08.00_wheelchair-validation.js";
import BookWheelchairFormValidation from "./components/c12.01_wheelchair-form-validation.js";
import BookWheelchairBasket from "./components/c08.01_wheelchair-basket.js";
import BookWheelchairListing from "./components/c08.02_wheelchair-list.js";
import DonateWidget from "./components/c10.01_donate-widget.js";
import WheelchairSelection from "./components/c11.01_wheelchair-selection.js";
import WheelchairModelOverlay from "./components/c11.04_wheelchair-model-overlay.js";
import WheelchairDetails from "./components/c12.01_wheelchair-details.js";
import "./components/c02.08_homepage-hero-yt.js";
import "./components/c04.08_case-study.js";
import "./components/c06.02_shop-list.js";
import "./components/c06.03_news-list.js";
import "./components/c06.04_event-list.js";
import "./components/c06.05_teaching-resources-list.js";
import "./components/c07.01_search-results.js";
import "./components/c04.05_related-links.js";
import "./components/c04.10_promotional-homepage-banner.js";
import "./components/footer.js";
import "./components/highlight.js";
import "./components/magnific-popup.js";
import HawStage3 from "./components/haw-stage-3";

if (document.querySelector(".language-selection")) {
  new LanguageSelection(document.querySelector(".language-selection"));
}

if (document.querySelector(".language-footer")) {
  new LanguageFooter(document.querySelector(".language-footer"));
}

if (
  document.querySelector(".site-header") &&
  document.querySelector(".component.navigation")
) {
  new HeaderNav(document.querySelector(".site-header"));
}

if (document.querySelector(".donation-module__form")) {
  new DonateWidget(document.querySelector(".donation-module__form"));
}

var donationWidgets = document.querySelectorAll(".donation-module__form");

for (let i = 0; i < donationWidgets.length; i += 1) {
  new DonateWidget(donationWidgets[i]);
}

if (document.querySelector(".homepage-hero")) {
  new HomepageVideo(document.querySelector(".homepage-hero"));
}

if (document.querySelector(".social-feed")) {
  var socialFeed = new SocialFeed(document.querySelector(".social-feed"));
  socialFeed.init();
}

if (document.querySelector(".feedback")) {
  new Feedback(document.querySelector(".feedback"));
}

if (document.querySelector(".wffm-form")) {
  wffm();
}

if (document.querySelector(".event-ticket-form")) {
  new EventTicketList(document.querySelector(".event-ticket-form"));
}

if (document.querySelector(".shop-map")) {
  var shopMaps = document.querySelectorAll(".shop-map");
  for (let i = 0; i < shopMaps.length; i++) {
    new ShopMap(shopMaps[i]).checkLocation();
  }
}

if (document.querySelector(".shop-details")) {
  var shopDetails = document.querySelectorAll(".shop-details");
  for (let i = 0; i < shopDetails.length; i++) {
    new ShopDetails(shopDetails[i]).checkLocation();
  }
}

if (document.querySelector(".services-list")) {
  var services = document.querySelectorAll(".services-list-item");
  for (let i = 0; i < services.length; i++) {
    new ServicesList(services[i]).checkLocation();
  }
}

if (document.querySelector(".cookie-banner")) {
  new CookieBanner(document.querySelector(".cookie-banner"));
}

var blockQuotes = document.querySelectorAll("blockquote");

for (let i = 0; i < blockQuotes.length; i += 1) {
  blockQuotes[i].setAttribute(
    "aria-label",
    "Quote: " + blockQuotes[i].innerHTML.trim()
  );
}

var postcodeLookups = document.querySelectorAll(".address-search");

for (let i = 0; i < postcodeLookups.length; i += 1) {
  new PostcodeLookup(postcodeLookups[i]);
}

if (document.querySelector(".toolkit")) {
  new ToolkitNavigation(document.querySelector(".toolkit"));
}

if (document.querySelector(".lightbox")) {
  new Lightbox(document.querySelector(".lightbox"));
}

//Book a wheelchair
if (document.querySelector(".js-wheelchair-validation")) {
  new BookWheelchairValidation(
    document.querySelector(".js-wheelchair-validation")
  );
}

//Book a wheelchair validation
if (document.querySelector(".js-wheelchair-form-validation")) {
  new BookWheelchairFormValidation(
    document.querySelector(".js-wheelchair-form-validation")
  );
}

//Wheelchair details
if (document.querySelector(".wheelchair-order-details")) {
  new WheelchairDetails(
    document.querySelector(".wheelchair-order-details")
  );
}

let wheelchairBasket = document.querySelector(".wheelchair-basket");
if (
  wheelchairBasket &&
  wheelchairBasket.querySelector("[data-duration-select]")
) {
  //Only load if user is able to change booking duration
  new BookWheelchairBasket(document.querySelector(".wheelchair-basket"));
}

if (document.querySelector(".wheelchair-list__item")) {
  var wheelchairListItems = document.querySelectorAll(".wheelchair-list__item");
  for (let i = 0; i < wheelchairListItems.length; i++) {
    if (wheelchairListItems[i].getAttribute("data-price-wc-input") != 0) {
      new BookWheelchairListing(wheelchairListItems[i]);
    }
  }
}

if (document.querySelector('.book-wheelchair-and-accessories')) {
  new HawStage3(document.querySelector('.book-wheelchair-and-accessories'));
}

if (document.querySelector(".wheelchair-selection")) {
  new WheelchairSelection(document.querySelector(".wheelchair-selection"));
}

if (document.querySelector(".wheelchair-model-overlay")) {
  new WheelchairModelOverlay(
    document.querySelectorAll(".js-open-overlay"),
  );
}

// IOS REPATCHA WORKAROUND
if (document.querySelector(".g-recaptcha")) {
  document
    .querySelector(".g-recaptcha")
    .setAttribute("data-callback", "onReCaptchaSuccess");
}

window.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
window.grecaptchaPosition;

window.isScrolledIntoView = function (elem) {
  var elemRect = elem.getBoundingClientRect();
  var isVisible = elemRect.top >= 0 && elemRect.bottom <= window.innerHeight;

  return isVisible;
};

window.recaptchaElements = document.querySelectorAll(".g-recaptcha");

if (window.isIOS) {
  window.addEventListener(
    "scroll",
    function () {
      Array.prototype.forEach.call(window.recaptchaElements, function (
        element
      ) {
        if (window.isScrolledIntoView(element)) {
          window.grecaptchaPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
        }
      });
    },
    false
  );
}

window.onReCaptchaSuccess = function () {
  console.log("onsuccess fired");
  console.log(window.isIOS, window.grecaptchaPosition);
  if (window.isIOS && window.grecaptchaPosition !== undefined) {
    window.scrollTo(0, window.grecaptchaPosition);
  }
};
// END WORKAROUND

// query string on donation links
if (window.donationQueryString) {
  var donationLinks = document.querySelectorAll(
      'a[href*="donate.redcross.org.uk"]'
    ),
    i;

  for (i = 0; i < donationLinks.length; i += 1) {
    if (donationLinks[i].href.indexOf("?") > -1) {
      donationLinks[i].href += "&" + window.donationQueryString;
    } else {
      donationLinks[i].href += "?" + window.donationQueryString;
    }
  }
}

//.closest polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  console.log("test");
  Element.prototype.closest = function (s) {
    console.log("test2");
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

if (document.querySelector(".js-video-modal")) {
  var videos = document.querySelectorAll(".js-video-modal");
  for (let i = 0; i < videos.length; i++) {
    new VideoModal(videos[i]);
  }
}

//if ('serviceWorker' in navigator) {
//    window.addEventListener('load', function () {
//        navigator.serviceWorker.register('/serviceWorker.js').then(function (registration) {
//            // Registration was successful
//            console.log('ServiceWorker registration successful with scope: ', registration.scope);
//        }, function (err) {
//            // registration failed :(
//            console.log('ServiceWorker registration failed: ', err);
//        });
//    });
//}
